import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-custom-notification',
  templateUrl: './custom-notification.component.html',
  styleUrls: ['./custom-notification.component.css']
})
export class CustomNotificationComponent implements OnInit {
  // msg=""
  constructor(private auth: AuthService,
    @Inject(MAT_SNACK_BAR_DATA) public msg: string,
    private router: Router,
    public snackBarRef: MatSnackBarRef<CustomNotificationComponent>) {
  }

  ngOnInit(): void {
  }

  redirect() {
    if(this.msg.startsWith('A new appointment')){
      this.router.navigate(['my-task', { tab: 'Pending Appointments' }])
      this.auth.pendingAppointments()
    }else if(this.msg.startsWith('A new referral')){
      this.router.navigate(['referrals', 'referrals'])
      this.auth.newReferrals()
    }else if(this.msg.startsWith('A new Patient')){
      this.router.navigate(['patients', 'patients'])
      this.auth.newPatients()
    }else if(this.msg.startsWith('A new rota')){
      this.router.navigate(['my-task', { tab: 'rota' }])
    }else{
      this.router.navigate(['my-task', { tab: 'Transfer Appointments' }])
    }
    this.snackBarRef.dismiss()
  }

  dismissNotification(){
    this.auth.pendingAppointments()
    this.auth.newReferrals()
    this.snackBarRef.dismiss()
  }
}
